import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

const ChildCategoryList = () => {
    const { parentId } = useParams();
    const [parentCategory, setParentCategory] = useState(null);
    const [childCategories, setChildCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { encryptedApiCall, API_BASE_URL, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [parentId]);

    const fetchData = async () => {
        try {
            setLoading(true);
            
            // Fetch parent category
            const parent = await encryptedApiCall(`${API_BASE_URL}/categories/${parentId}`, {
                method: 'GET'
            });
            setParentCategory(parent);

            // Fetch child categories
            const children = await encryptedApiCall(`${API_BASE_URL}/categories?parentId=${parentId}`, {
                method: 'GET'
            });
            setChildCategories(children);
        } catch (err) {
            if (err.message && err.message.includes('401')) {
                logout();
                navigate('/login');
                return;
            }
            setError(err.message || 'Failed to fetch categories');
        } finally {
            setLoading(false);
        }
    };

    const handleChildCategoryClick = (categoryId) => {
        navigate(`/tests?categoryId=${categoryId}`);
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <div className="mb-4">
                <Button 
                    variant="outline-secondary" 
                    onClick={() => navigate('/categories')} 
                    className="me-2"
                >
                    ← Back to Categories
                </Button>
                <h2 className="d-inline ms-3">
                    {parentCategory?.name || 'Category'}
                </h2>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            {childCategories.length === 0 ? (
                <Alert variant="info">No child categories available.</Alert>
            ) : (
                <div className="row">
                    {childCategories.map((category) => (
                        <div key={category.id} className="col-md-4 mb-3">
                            <Card 
                                style={{ cursor: 'pointer', height: '100%' }}
                                onClick={() => handleChildCategoryClick(category.id)}
                            >
                                <Card.Body>
                                    <Card.Title>{category.name}</Card.Title>
                                    <Card.Text className="text-muted">
                                        {category.description || 'No description'}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                    ))}
                </div>
            )}
        </Container>
    );
};

export default ChildCategoryList;

